const variantdataEl = document.querySelector(`[data-product-variants]`)
const productvariantsData = variantdataEl ? JSON.parse(variantdataEl.textContent) : {}

let initialPageLoad = false

const handleABTest = (e) => {
  if (initialPageLoad) return
  const strengthOption = document.querySelector(`[data-option-name="Strength"]`)
  const flavorOption =
    document.querySelector(`[data-option-name="Flavor"]`) ||
    document.querySelector(`[data-option-name="Flavour"]`)
  if (strengthOption) {
    strengthOption.style.display = "none"
  }
  if (e.detail.action === "show") {
    const availableVariants = []
    const actionVariants = e.detail.variants
    actionVariants.forEach((variant) => {
      const exists = productvariantsData.find(
        (productVariant) => productVariant.id === Number(variant)
      )
      if (exists && flavorOption) {
        const flavorTitle = exists[`option${Number(flavorOption.dataset.optionIndex) + 1}`]
        if (flavorTitle) {
          availableVariants.push(flavorTitle)
        }
      }
    })

    const flavorSelect = flavorOption.querySelector("select")
    if (flavorSelect) {
      // remove select options that are not in the available variants
      const options = flavorSelect.querySelectorAll("option")
      options.forEach((option) => {
        if (!availableVariants.includes(option.value)) {
          option.remove()
        }
      })
      const currentFlavor = flavorSelect.value
      if (!availableVariants.includes(currentFlavor)) {
        flavorSelect.value = availableVariants[0]
        const event = new Event("change")
        flavorOption.querySelector("select").dispatchEvent(event)
        flavorSelect.dispatchEvent(new CustomEvent("swatch:change", { bubbles: true }))
      }
    }

    initialPageLoad = true
  }
}

document.addEventListener("a/b_test:variants", handleABTest)
